(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
const init = () => {
document.querySelectorAll('[data-cw-infinite]').forEach((grid) => {
if (grid.dataset.cwReady || !('IntersectionObserver' in window)) return;
const pager = grid.querySelector('[data-cw-pagination]');
let next = pager?.querySelector('.next a');
if (!pager || !next) return;
grid.dataset.cwReady = 'true';
const marker = document.createElement('div');
marker.style.cssText = 'grid-column:1/-1;height:1px';
marker.setAttribute('aria-hidden', 'true');
grid.append(marker);
pager.hidden = true;
let busy = false;
const visited = new Set();
const observer = new IntersectionObserver(async (entries) => {
if (!entries.some((entry) => entry.isIntersecting) || busy || !next) return;
const url = next.href;
if (visited.has(url)) { observer.disconnect(); return; }
busy = true;
grid.setAttribute('aria-busy', 'true');
try {
const response = await fetch(url, { credentials: 'same-origin' });
if (!response.ok) throw new Error('collection');
const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
const incoming = doc.querySelector('[data-cw-infinite]');
if (!incoming) throw new Error('grid');
const incomingPager = incoming.querySelector('[data-cw-pagination]');
const cards = [...incoming.children].filter((child) => !child.matches('[data-cw-pagination], [data-cw-draft-card]'));
if (!cards.length) throw new Error('products');
cards.forEach((card) => grid.insertBefore(document.importNode(card, true), pager));
visited.add(url);
pager.innerHTML = incomingPager?.innerHTML || '';
next = pager.querySelector('.next a');
if (!next) { observer.disconnect(); marker.remove(); pager.remove(); }
else { observer.unobserve(marker); observer.observe(marker); }
} catch {
observer.disconnect();
pager.hidden = false;
marker.remove();
} finally {
busy = false;
grid.removeAttribute('aria-busy');
}
}, { rootMargin: '600px 0px' });
observer.observe(marker);
});
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
